import { render } from "./QnaConfig.vue?vue&type=template&id=fbb66b20&scoped=true"
import script from "./QnaConfig.vue?vue&type=script&lang=js"
export * from "./QnaConfig.vue?vue&type=script&lang=js"

import "./QnaConfig.vue?vue&type=style&index=0&id=fbb66b20&scoped=true&lang=css"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbb66b20"]])

export default __exports__